module.exports = {"platforms":[{"message":"top platform","type":"FiniteImmobilePlatform","x":224,"y":288,"width":352,"height":32,"display":{"assetName":"grass"}},{"message":"start platform","type":"FiniteImmobilePlatform","x":288,"y":448,"width":224,"height":32,"display":{"assetName":"grass"}}],"goal":{"x":384,"y":448},"player":{"x":384,"y":192},"par":1}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-3-cut-2.json
// module id = 140
// module chunks = 0